import React from 'react';
import ResourceComponent from '../../common/ResourceComponent';
import PropTypes from 'prop-types';
import {bindActionCreators} from 'redux';
import * as actions from './EmbeddableApi';
import {connect} from 'react-redux';
import {colorBlockFormatter, dollarsFormatter, impactFormatter, percentage} from '../../common/TableFormatters';
import {Badge, Button, Col, Row} from 'reactstrap';
import defaultImage from './utils/no_image.png';
import ShareButton from './utils/ShareButton';
import {getMaterialImageAlt, isFeatureFlagEnabled} from '../../common/Utils';

class EmbSlabItem extends ResourceComponent {

    state = {
        showTooltip: false,
        imagesStatus: {},
    };

    copyToClipboard = (id) => {
        const temp = document.createElement('textarea');
        document.body.appendChild(temp);
        temp.value = `https://${location.hostname}/slabs?item_id=${id}`;
        temp.select();
        document.execCommand('copy');
        this.setState({showTooltip: id},
            () => setTimeout(
                () => this.setState({showTooltip: false}), 3000),
        );
    };

    render() {
        const {showTooltip, imagesStatus, filter} = this.state;
        const {
            settings, card_detail, slab, index, ecommerceConnected, checkClaimed, onUnclaim, onClaim,
            onSlabClick, claimEnabled, sendEventData,
        } = this.props;
        const isCarbonSmartWoodEnabled = isFeatureFlagEnabled(this.props.profile, 'Carbon Smart Wood');

        return (
            <Col key={slab.id}
                 className={`mt-4 pointer align-content-center item-container ${index === 0 ? 'first-slab-item-margin ' : ' '}
                 ${filter ? 'col-12 col-sm-12 col-md-6 col-lg-4' : 'col-12 col-sm-6 col-md-4 col-lg-3'}
                 `}
                 onClick={() => {
                     onSlabClick(slab.id);
                     sendEventData('view_item', {
                         currency: 'USD',
                         value: slab.price,
                         items: [{
                             item_name: `Slab: ${slab.number}`,
                             price: slab.price,
                         }],
                     });
                 }}>
                <div
                    className='item-content'
                    style={{backgroundColor: settings.card_container_color ? settings.card_container_color : null}}>
                    {card_detail.sale_discount_index && slab.discount && slab.price !== slab.base_price &&
                        <div style={{position: 'relative'}}>
                            <div
                                className='discount-banner'
                                style={{
                                    position: card_detail.show_images_index ? 'absolute' : 'inherit',
                                    opacity: card_detail.banner_transparency,
                                    backgroundColor: settings.banner_color_index ? settings.banner_color_index : 'transparent',
                                    color: settings.font_color_index ? settings.font_color_index : 'black',
                                }}>
                                <span className='sale'>SALE!</span>
                                <span
                                    className='discount'>{percentage(slab.price, slab.price_no_discount)}</span>
                            </div>
                        </div>
                    }
                    {card_detail.show_images_index &&
                        <React.Fragment>
                            <div className='image-container'>
                                <img
                                    alt={getMaterialImageAlt(slab, slab.picture)}
                                    src={slab.picture && slab.picture.large_url ? slab.picture.large_url : (settings.slab_default_pic_url
                                        ? settings.slab_default_pic_url
                                        : defaultImage)}
                                    onLoad={() => {
                                        imagesStatus.id = true;
                                        this.setState({imagesStatus});
                                    }}
                                />
                            </div>
                        </React.Fragment>
                    }

                    <div className='body'>
                        <div className='item-data border-top'>
                            <Row className='m-2'>
                                {card_detail.tree_name_index &&
                                    <Col xs={12}
                                         className='d-flex justify-content-center pl-0 pr-0 mr-0'>
                                    <span className='h5'>
                                        {settings.show_color_block ? colorBlockFormatter(slab.name, slab.color) : slab.name}
                                    </span>
                                    </Col>
                                }
                                {card_detail.number_index &&
                                    <Col xs={12}
                                         className={'d-flex justify-content-center pl-0 pr-0'}>
                                        <Badge
                                            className={'float-right custom-badge'}
                                            color='light'>
                                            <b>{slab.number}</b>
                                        </Badge>
                                    </Col>
                                }
                            </Row>
                            <div className='pt-2 pb-2 pl-2 pr-2 border-top'>
                                {card_detail.source_type_index &&
                                    <Row>
                                        <Col xs={5} className='pr-0 mr-0'>
                                            <small>Source Type:</small>
                                        </Col>
                                        <Col xs={7} className='pl-1 text-right'>
                                            <b className='h5'>{slab.source_type}</b>
                                        </Col>
                                    </Row>
                                }
                                {isCarbonSmartWoodEnabled && card_detail.carbon_smart_wood_index &&
                                    <Row>
                                        <Col xs={9} className='pr-0 mr-0'>
                                            <small style={{whiteSpace: 'nowrap'}}>Carbon Smart Wood&trade;:</small>
                                        </Col>
                                        <Col xs={3} className='pl-1 text-right'>
                                            <b className='h5'>{slab.carbon_smart_wood ? 'Yes' : 'No'}</b>
                                        </Col>
                                    </Row>
                                }
                                {card_detail.location_index &&
                                    <Row>
                                        <Col xs={4} className='pr-0 mr-0'>
                                            <small>Location:</small>
                                        </Col>
                                        <Col xs={8} className='pl-1 text-right'>
                                            <b className='h5'>{slab.location}</b>
                                        </Col>
                                    </Row>
                                }
                                {slab.formula === 'Slab' &&
                                    <React.Fragment>
                                        {card_detail.length_index &&
                                            <Row>
                                                <Col xs={8} className='pr-0 mr-0'>
                                                    <small>Length:</small>
                                                </Col>
                                                <Col xs={4} className='pl-1 text-right'>
                                                    <b className='h5'>{slab.length}{'"'}</b>
                                                </Col>
                                            </Row>
                                        }
                                        {slab.average_width ?
                                            <Row>
                                                <Col xs={8} className='pr-0 mr-0'>
                                                    <small>Average width:</small>
                                                </Col>
                                                <Col xs={4} className='pl-1 text-right'>
                                                    <b className='h5'>{slab.average_width}{'"'}</b>
                                                </Col>
                                            </Row>
                                            : <React.Fragment>
                                                {card_detail.min_width_index &&
                                                    <Row>
                                                        <Col xs={8} className='pr-0 mr-0'>
                                                            <small>Min width:</small>
                                                        </Col>
                                                        <Col xs={4} className='pl-1 text-right'>
                                                            <b className='h5'>{slab.width_minimum}{'"'}</b>
                                                        </Col>
                                                    </Row>
                                                }
                                                {card_detail.max_width_index &&
                                                    <Row>
                                                        <Col xs={8} className='pr-0 mr-0'>
                                                            <small>Max width:</small>
                                                        </Col>
                                                        <Col xs={4} className='pl-1 text-right'>
                                                            <b className='h5'>{slab.width_maximum}{'"'}</b>
                                                        </Col>
                                                    </Row>
                                                }
                                            </React.Fragment>
                                        }
                                    </React.Fragment>
                                }
                                {slab.formula === 'Cylinder' &&
                                    <Row>
                                        <Col xs={8} className='pr-0 mr-0'>
                                            <small>Diameter:</small>
                                        </Col>
                                        <Col xs={4} className='pl-1 text-right'>
                                            <b className='h5'>{slab.diameter}{'"'}</b>
                                        </Col>
                                    </Row>
                                }
                                {card_detail.thickness_index &&
                                    <Row>
                                        <Col xs={8} className='pr-0 mr-0'>
                                            <small>Thickness:</small>
                                        </Col>
                                        <Col xs={4} className='pl-1 text-right'>
                                            <b className='h5'>{slab.thick}{'"'}</b>
                                        </Col>
                                    </Row>
                                }
                                {card_detail.surfaced_thickness_index}
                                {card_detail.surfaced_thickness_index &&
                                    <Row>
                                        <Col xs={9} className='pr-0 mr-0'>
                                            <small>Surfaced Thickness:</small>
                                        </Col>
                                        <Col xs={3} className='pl-1 text-right'>
                                            <b className='h5'>{slab.surfaced_thickness}{'"'}</b>
                                        </Col>
                                    </Row>
                                }
                                {card_detail.board_feet_index &&
                                    <Row>
                                        <Col xs={8} className='pr-0 mr-0'>
                                            <small>Board feet:</small>
                                        </Col>
                                        <Col xs={4} className='pl-1 text-right'>
                                            <b className='h5'>{slab.total_bf}</b>
                                        </Col>
                                    </Row>
                                }
                                {card_detail.bf_price_index &&
                                    <Row>
                                        <Col xs={8} className='pr-0 mr-0'>
                                            <small>BF price:</small>
                                        </Col>
                                        <Col xs={4} className='pl-1 text-right'>
                                            <b className='h5'>{dollarsFormatter(slab.bf_price)}</b>
                                        </Col>
                                    </Row>
                                }
                                {settings.show_carbon_impact &&
                                    <Row>
                                        <Col xs={6} className='pr-0 mr-0'>
                                            <small>Carbon Impact:</small>
                                        </Col>
                                        <Col xs={6} className='pl-1 text-right'>
                                            <b className='h5'>{impactFormatter(slab.carbon_impact_mt)}</b>
                                        </Col>
                                    </Row>
                                }
                                <Row>
                                    {card_detail.share_button_index &&
                                        <ShareButton item={slab} showTooltip={showTooltip}
                                                     copyToClipboard={this.copyToClipboard} />
                                    }
                                </Row>
                            </div>
                        </div>
                        {((claimEnabled || (ecommerceConnected)) || card_detail.price_index) &&
                            <Row className='m-0 item-summary p-3 pt-0 border-top align-self-end'>
                                {card_detail.price_index &&
                                    <Col xs={12}
                                         className='d-inline-block p-1 text-right d-flex justify-content-center'>
                                        {card_detail.discount_label_index && slab.discount && slab.price !== slab.base_price ?
                                            <div className='discount-price'>
                                                <h3 style={{fontSize: card_detail.discount_font_size_index}}
                                                    className='discounted-price'>{slab.price ? dollarsFormatter(slab.price) : ''}
                                                </h3>
                                                <h4 style={{fontSize: card_detail.price_font_size_index}}
                                                    className='base_price'>
                                                    {slab.price ? dollarsFormatter(slab.price_no_discount) : ''}
                                                </h4>
                                            </div> :
                                            <h3 style={{fontSize: card_detail.price_font_size_index}}
                                                className='m-0'>{slab.price ? dollarsFormatter(slab.price) : ''}
                                            </h3>
                                        }
                                    </Col>
                                }
                                {(claimEnabled || (!claimEnabled && ecommerceConnected)) && slab.for_sale &&
                                    <Col
                                        className='p-1 m-0 d-flex justify-content-center'>
                                        {checkClaimed(slab)
                                            ? <Button size='sm' color='info'
                                                      onClick={(e) => {
                                                          e.stopPropagation();
                                                          onUnclaim(slab);
                                                      }}>
                                                {claimEnabled ? 'ON HOLD' : 'In cart'}
                                            </Button>
                                            : <Button size='sm' color='danger'
                                                      onClick={(e) => {
                                                          e.stopPropagation();
                                                          onClaim(slab);
                                                      }}>
                                                {claimEnabled ? 'Claim Item' : 'Add to Cart'}
                                            </Button>
                                        }
                                    </Col>
                                }
                            </Row>}
                    </div>
                </div>
            </Col>
        );
    }
}

EmbSlabItem.contextTypes = {
    router: PropTypes.object,
};

EmbSlabItem.propTypes = {
    actions: PropTypes.object,
    history: PropTypes.object,
};

const mapStateToProps = ({appState}) => ({
    profile: appState.profile,
    claimedItems: appState.claimedItems,
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(
        actions,
        dispatch),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(EmbSlabItem);


// WEBPACK FOOTER //
// ./src/containers/embeddable/EmbSlabItem.js